import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { isCourtDrive } from '../../../util/globalUtils';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');

const getAdvancedSearchAllCourtsLink = (keyword, caseUuid) =>
  `/advanced-search?keys=${keyword ||
    '*'}&court_type=&search_pdfs=include&query[]=dockets&template=general&case_uuid=${caseUuid}&do_search=1`;

const getAdvancedSearchBankruptcyLink = (keyword, caseUuid) =>
  `/advanced-search?keys=${keyword ||
    '*'}&court_type=bankruptcy&search_pdfs=include&query[]=dockets&template=general&case_uuid=${caseUuid}&do_search=1`;

class DocketFilters extends Component {
  changeText = e => {
    e.persist();
    this.props.onChange(e, 'search_keyword');
  };

  keydown = e => {
    // only respond to tabbing through or enter.
    // Sometimes we need to blur out for other clicks that dont trigger a buy (ie cancel button)
    if (e.keyCode === 13 || e.keyCode === 9) {
      this.props.getFilteredDockets();
    }
  };

  handleSubmit = (e) => {
    const { getFilteredDockets } = this.props;
    e.preventDefault();
    getFilteredDockets();
  };

  render() {
    const {
      keyword,
      doc_range,
      date_filed_from,
      date_filed_to,
      changeDate,
      onChangeDateRaw,
      onChange,
      onClear,
      caseUuid,
    } = this.props;

    return (
      <div id="docket-filters">
        <form id="parser-docket-form" onSubmit={this.handleSubmit}>
          <span className="form-group">
            <input
              type="text"
              name="keyword"
              id="alfresco-keyword"
              className="form-text"
              size="30"
              value={keyword}
              onKeyDown={this.keydown}
              onChange={this.changeText}
              placeholder="Enter Keywords"
            />
            <a
              href={
                isCourtDrive()
                  ? getAdvancedSearchAllCourtsLink(keyword, caseUuid)
                  : getAdvancedSearchBankruptcyLink(keyword, caseUuid)
              }
              title="Go to Advanced Search"
            >
              <i className="fa fa-search"></i>
            </a>
          </span>
          <input
            type="text"
            name="doc_range"
            id="alfresco-doc-range"
            size="20"
            className="form-text valid"
            value={doc_range}
            onChange={e => onChange(e, 'doc_range')}
            onKeyDown={this.keydown}
            placeholder="Doc# Ex: 1,3,4-7"
          />
          <div className="date-selector">
            <DatePicker
              selected={date_filed_from}
              onChange={changeDate.bind(null, 'date_filed_from')}
              dateFormat="MM/DD/YYYY"
              className=""
              placeholderText="date"
              onChangeRaw={onChangeDateRaw.bind(null, 'date_filed_from')}
            />
          </div>
          <span>&nbsp;to&nbsp;</span>
          <div className="date-selector">
            <DatePicker
              selected={date_filed_to}
              onChange={changeDate.bind(null, 'date_filed_to')}
              dateFormat="MM/DD/YYYY"
              className=""
              placeholderText="date"
              onChangeRaw={onChangeDateRaw.bind(null, 'date_filed_to')}
            />
          </div>
          <button type="submit" className="form-submit" value="Submit">
            <span className="magnifier icon" />
          </button>
          <div id="alfresco-clear" className="clear-button" onClick={onClear}>
            clear
          </div>
        </form>
      </div>
    );
  }
}

DocketFilters.defaultProps = {
  date_filed_from: null,
  date_filed_to: null,
};

DocketFilters.propTypes = {
  keyword: PropTypes.string.isRequired,
  doc_range: PropTypes.string.isRequired,
  changeDate: PropTypes.func.isRequired,
  onChangeDateRaw: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  getFilteredDockets: PropTypes.func.isRequired,
  date_filed_from: PropTypes.object,
  date_filed_to: PropTypes.object,
};

export default DocketFilters;



// WEBPACK FOOTER //
// ./src/components/case/docket/DocketFilters.jsx